export interface ISpreadsheetCommunicator {
    /**
     * Get value from currently select cell 
    */
    read_formula(formulaStyle: string);
    read_numberDecimalSeparator();
    read_displayLanguage();
    read_contentLanguage();

    /**
    * Write value to currently selected cell
    * @param value
    * @param formulaStyle 
    */
    write_formula(value: string, formulaStyle: string);

    /**
     * 
     * @param handler 
     * @returns true if added 
     */
    addOnSelectionChangeHandler(handler);
}
export abstract class AbstractSpreadsheetCommunicator implements ISpreadsheetCommunicator {
    isWriting: boolean = false;
    isReading: boolean = false;
    lastSelection = { row: -1, column: -1 };
    abstract read_formula(formulaStyle: string);
    abstract read_numberDecimalSeparator();
    abstract read_displayLanguage();
    abstract read_contentLanguage();
    abstract write_formula(value: string, formulaStyle: string);
    abstract addOnSelectionChangeHandler(handler);
}